import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from "~/atoms/alert";

/** Prompts the receiving unit to give a shared copy a category and a tier. */
export const UnclassifiedSharedCopyWarning = () => {
  const { t } = useTranslation();

  return (
    <Alert variant="warn" className="w-fit">
      <AlertTriangle className="text-warning-foreground! dark:text-warning-strong!" />
      <AlertTitle>
        {t(($) => $.documentSharing.notice.needsCategory)}
      </AlertTitle>
    </Alert>
  );
};
